import { coreTagsIdMapRemoveSlice } from './remove';
import { coreTagsIdMapSlice } from './update';
import { defaultTagsIdMapState } from './state';
import { joinSyncReducers } from '@sonar-software/xuder';

export const coreTagsIdMapReducers = joinSyncReducers(
	[ coreTagsIdMapSlice.syncReducer, coreTagsIdMapRemoveSlice.syncReducer ],
	defaultTagsIdMapState
);
